import useAppStore from "@/context/store";
import { useAsyncEffect, useMount } from "ahooks";
import QueryString from "qs";
import { useRef } from "react";
import { type IModalInstance } from "../HBModal/ModalWrap";

export default function useImagePreview() {
  const { currentPreview } = useAppStore(({ currentPreview }) => ({
    currentPreview,
  }));

  const modalRef = useRef<IModalInstance>(null);

  useMount(async () => {
    let { modalImg } = QueryString.parse(location.search.slice(1));
    if (modalImg) {
      useAppStore.setState({ currentPreview: { src: modalImg } });
    }
  });

  useAsyncEffect(async () => {
    if (currentPreview?.src) {
      const { default: PreviewModal } = await import("./index");
      if (!modalRef.current) {
        modalRef.current = PreviewModal.open();
      }
    } else {
      modalRef.current?.destroy();
      modalRef.current = null;
    }
  }, [currentPreview]);
}
